export enum OVERLAY {
  CAMERA = "camera",
  QRSCAN = "qrscan",
  CST_DESKTOP_RESULTS = "cstDesktopResults",
  UNSUPPORTED_COUNTRY = "unsupportedcountry",
}
